// extracted by mini-css-extract-plugin
module.exports = {"bubbles":"ShareBubbles_bubbles__tFAYS","bubbleContainer":"ShareBubbles_bubbleContainer__1a46f","bubble":"ShareBubbles_bubble__2DBh_"};